import 'babel-polyfill';

import Vue from 'vue';

// 引入element-ui自定义主题
import 'element-ui/lib/theme-chalk/index.css';
// import '../theme/index.css';
import './assets/css/final-cascader.css';
// 字体库
import './assets/font/index.less';
import 'viewerjs/dist/viewer.css';
import NProgress from 'vue-nprogress';
import Viewer from 'v-viewer';
import App from './App';
import ElementUI from 'element-ui';
import 'font-awesome/css/font-awesome.min.css';
import store from './store';
import accounting from 'accounting';
import router from './router';
import directives from './directives/';

// 接入版本更新提醒check
import SimpleUpdateDetector from '@qtt/web-update-checker';
import { MessageBox } from 'element-ui';
new SimpleUpdateDetector({
  // checkInterval: 5 * 60 * 1000, // 默认5分钟
  onUpdate: (version, oldVersion, tmUpdate) => {
    console.log(`新版本: ${version}, 旧版本: ${oldVersion}, 最后更新时间: ${tmUpdate}`);
    MessageBox.confirm(
      `发现新版本(${version}), 是否立即刷新页面`,
      '版本更新提醒',
      {
        confirmButtonText: '立即刷新',
        cancelButtonText: '稍后再说',
        type: 'warning'
      }
    ).then(() => {
      try {
        // const cacheSysUserInfo = window.localStorage.getItem('cache_sys_user_info');

        window.localStorage.clear();
        // if (cacheSysUserInfo !== null) {
        //   window.localStorage.setItem('cache_sys_user_info', cacheSysUserInfo);
        // }
        window.sessionStorage.clear();
      } catch (err) {
        console.warn('清理浏览器缓存失败:', err);
      }

      // 强制刷新
      const url = new window.URL(window.location.href);
      url.searchParams.set('_update', String(Date.now()));
      window.location.href = url.toString();

      // 普通刷新
      // window.location.reload();
    }).catch(() => {});
  }
}).init();

// 发起请求时的时间参数统一格式
Vue.prototype.$REQUEST_DATE_FORMAT = 'YYYY-MM-DD';

Vue.use(ElementUI);
Vue.use(NProgress);
Vue.use(Viewer);

const nprogress = new NProgress({
  parent: '.nprogress-container',
});

Vue.mixin({
  created() {
    if (this.filter) {
      this.filter = this.$queryFilter();
      this.$updateRouter(this.filter);
    }
  },
  methods: {
    $queryFilter() {
      let filter = this.filter || {};
      if (this.$route) {
        let query = this.$route.query;
        for (let i in filter) {
          if (typeof query[i] !== 'undefined') {
            if (typeof filter[i] === 'number') {
              filter[i] = parseInt(query[i], 10);
            } else {
              filter[i] = query[i];
            }
          }
        }
      }
      return filter;
    },
    $updateRouter(query) {
      if (!query) {
        // eslint-disable-next-line no-param-reassign
        query = this.$queryFilter();
      }
      this.$router.replace({
        query: { ...query },
      });
    },
    $blockRequest({ $elem, req, pendingText = '操作中' }) {
      if (!$elem) {
        // eslint-disable-next-line no-param-reassign
        $elem = document.createElement('button');
      }
      if (!$elem || $elem._req_block) return;

      let isButton = $elem.nodeName.toLowerCase() === 'button';
      let oText = $elem.innerText;

      if (isButton) $elem.setAttribute('disabled', true);

      $elem.innerText = pendingText;
      $elem._req_block = true;

      return req.fin(() => {
        if (isButton) $elem.removeAttribute('disabled');
        $elem._req_block = false;
        $elem.innerText = oText;
      });
    },
  },
});

Vue.filter('currencyMoney', function(value) {
  if (!value) return '-';
  return accounting.formatMoney(value, '￥');
});

Vue.filter('currencyNumber', function(value) {
  if (!value) return '-';
  return accounting.formatNumber(value);
});

// 注册自定义指令
Object.keys(directives).forEach((key) => {
  const { name, directive } = directives[key];
  Vue.directive(name, directive);
});

new Vue({
  router,
  store,
  nprogress,
  render: (h) => h(App),
}).$mount('#app');
